import { type RouteObject } from "react-router";
import { loadStripe } from "@stripe/stripe-js/pure";
import SubscriptionDetailPage from "Subscription/Detail/App";
import StripeSetupIntentCompletePanel from "Stripe/SetupIntentComplete/app";

declare let viewModel: any;

export const subscriptionRoute: RouteObject = {
  path: "subscription",
  children: [{
    index: true,
    loader: () => {
      const stripePromise = loadStripe(site.deploymentValues.stripePublishableKey);
      return ({
        viewModel: viewModel as server.viewmodel.SubscriptionDetailFrontModel,
        stripePromise,
      });
    },
    Component: SubscriptionDetailPage,
  }, {
    path: "payment-setup-complete",
    loader: () => {
      const stripePromise = loadStripe(site.deploymentValues.stripePublishableKey);
      return ({
        viewModel: viewModel as server.viewmodel.SubscriptionPaymentSetupCompleteFrontModel,
        stripePromise,
      });
    },
    Component: StripeSetupIntentCompletePanel,
  }]
}
